module.exports = __webpack_public_path__ + "static/media/download-cloud.7e595be3.svg";